export const profileCarouselForwardButton = {
  style: {
    alignSelf: "center",
    border: "none",
    borderBottomLeftRadius: "50%",
    borderTopLeftRadius: "50%",
    color: "white",
    cursor: "pointer",
    fontSize: "20px",
    height: "100%",
    lineHeight: 1,
    textAlign: "center" as const,
    width: 30,
  },
  children: ">" as React.ReactNode,
  className: "carouselForwardArrow",
};

export const profileCarouselBackwardButton = {
  style: {
    alignSelf: "center",
    border: "none",
    borderBottomRightRadius: "50%",
    borderTopRightRadius: "50%",
    color: "white",
    cursor: "pointer",
    fontSize: "20px",
    height: "100%",
    lineHeight: 1,
    textAlign: "center" as const,
    width: 30,
  },
  children: "<" as React.ReactNode,
  className: "carouselBackArrow",
};

export const profileCarouselResponsive = [
  {
    itemsToShow: 11,
    itemsToScroll: 1,
    maxWidth: 1250,
  },
  {
    itemsToShow: 10,
    itemsToScroll: 1,
    maxWidth: 1200,
  },
  {
    itemsToShow: 9,
    itemsToScroll: 1,
    maxWidth: 1100,
  },
  {
    itemsToShow: 8,
    itemsToScroll: 1,
    maxWidth: 1050,
  },
  {
    itemsToShow: 7,
    itemsToScroll: 1,
    maxWidth: 900,
  },
  {
    itemsToShow: 6,
    itemsToScroll: 1,
    maxWidth: 800,
  },
  {
    itemsToShow: 5,
    itemsToScroll: 1,
    maxWidth: 750,
  },
  {
    itemsToShow: 4,
    itemsToScroll: 1,
    maxWidth: 650,
  },
  {
    itemsToShow: 3,
    itemsToScroll: 1,
    maxWidth: 600,
  },
];
export const profileMobileCarouselResponsive = [
  {
    itemsToShow: 12,
    itemsToScroll: 1,
    maxWidth: 1000,
  },
  {
    itemsToShow: 11,
    itemsToScroll: 1,
    maxWidth: 950,
  },
  {
    itemsToShow: 10,
    itemsToScroll: 1,
    maxWidth: 900,
  },
  {
    itemsToShow: 9,
    itemsToScroll: 1,
    maxWidth: 850,
  },
  {
    itemsToShow: 8,
    itemsToScroll: 1,
    maxWidth: 750,
  },
  {
    itemsToShow: 7,
    itemsToScroll: 1,
    maxWidth: 650,
  },
  {
    itemsToShow: 6,
    itemsToScroll: 1,
    maxWidth: 600,
  },
  {
    itemsToShow: 5,
    itemsToScroll: 1,
    maxWidth: 500,
  },
  {
    itemsToShow: 4,
    itemsToScroll: 1,
    maxWidth: 450,
  },
  {
    itemsToShow: 3,
    itemsToScroll: 1,
    maxWidth: 350,
  },
  {
    itemsToShow: 2,
    itemsToScroll: 1,
    maxWidth: 300,
  },
  {
    itemsToShow: 1,
    itemsToScroll: 1,
    maxWidth: 200,
  },
];

export const characterPageCarouselResponsive = [
  {
    itemsToShow: 11,
    itemsToScroll: 1,
    maxWidth: 1250,
  },
  {
    itemsToShow: 10,
    itemsToScroll: 1,
    maxWidth: 1200,
  },
  {
    itemsToShow: 9,
    itemsToScroll: 1,
    maxWidth: 1100,
  },
  {
    itemsToShow: 8,
    itemsToScroll: 1,
    maxWidth: 1050,
  },
  {
    itemsToShow: 7,
    itemsToScroll: 1,
    maxWidth: 1000,
  },
  {
    itemsToShow: 6,
    itemsToScroll: 1,
    maxWidth: 900,
  },
  {
    itemsToShow: 5,
    itemsToScroll: 1,
    maxWidth: 800,
  },
  {
    itemsToShow: 4,
    itemsToScroll: 1,
    maxWidth: 750,
  },
  {
    itemsToShow: 3,
    itemsToScroll: 1,
    maxWidth: 650,
  },
  {
    itemsToShow: 2,
    itemsToScroll: 1,
    maxWidth: 400,
  },
  {
    itemsToShow: 1,
    itemsToScroll: 1,
    maxWidth: 320,
  },
];
